import { render } from "./ChangePasswordModal.vue?vue&type=template&id=130be8c1&scoped=true&ts=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=ts"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=130be8c1&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130be8c1"]])

export default __exports__